import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import shortTermRentalTips from '../../content/cleaning-tips/guides/short-term-rentals.json';

const TipCard = ({ tip }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Typography variant="h6">{tip.title}</Typography>
      <Typography variant="body2" color="text.secondary">
        {tip.description}
      </Typography>
      <Button size="small" sx={{ mt: 1 }}>Read More</Button>
    </CardContent>
  </Card>
);

const ShortTermRentalGuides = () => {
  const [tips, setTips] = useState([]);

  useEffect(() => {
    setTips(shortTermRentalTips);
  }, []);

  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Short-Term Rental Cleaning Guides
      </Typography>
      <Grid container spacing={3}>
        {tips.map(tip => (
          <Grid item xs={12} sm={6} md={4} key={tip.id}>
            <TipCard tip={tip} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ShortTermRentalGuides;
